export class NoResponseError {
  request: XMLHttpRequest

  constructor(request: XMLHttpRequest) {
    this.request = request
  }
}
